import React from "react";
import { Mill } from "~/types/mill";

interface Props {
  mill?: Mill;
}

const ProductBrandLink: React.FC<Props> = ({ mill }) => {
  if (!mill) {
    return null;
  }

  return (
    <a
      aria-label={`${mill.name} link`}
      className="hidden lg:block"
      href={`/${mill.slug}`}
    >
      <img
        alt={`${mill.name} brand logo`}
        className="max-h-[80px] max-w-[180px]"
        src={mill.logo.color ?? mill.brandLogo}
      />
    </a>
  );
};

export default ProductBrandLink;
